module.exports = __webpack_public_path__ + "img/NormaticaDisplay-Demo.737fa40d.svg";